import { render, staticRenderFns } from "./NoticeSetting.vue?vue&type=template&id=49e57217"
import script from "./NoticeSetting.vue?vue&type=script&lang=js"
export * from "./NoticeSetting.vue?vue&type=script&lang=js"
import style0 from "./NoticeSetting.vue?vue&type=style&index=0&id=49e57217&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports